/**
 * 이미지 파일에서 EXIF 메타데이터를 제거합니다.
 * AWS WAF 등 EXIF 포함 파일을 차단하는 정책을 피하기 위해 업로드 전 호출합니다.
 * Canvas로 재인코딩하여 EXIF를 제거하며, 외부 라이브러리 없이 동작합니다.
 */
const IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
/**
 * 파일이 EXIF 제거 대상 이미지인지 여부
 * @param file - 검사할 파일
 * @returns 이미지 타입이면 true
 */
export function isImageFileWithExif(file) {
    return IMAGE_MIME_TYPES.some((type) => file.type === type);
}
/**
 * 이미지 파일에서 EXIF 메타데이터를 제거합니다.
 * Canvas에 그린 뒤 Blob으로 내보내 EXIF를 제거합니다.
 * 이미지가 아니거나 재인코딩 실패 시 원본 파일을 그대로 반환합니다.
 *
 * @param file - 원본 파일
 * @returns EXIF가 제거된 새 File (이미지가 아니거나 실패 시 원본 반환)
 */
export async function stripExifFromFile(file) {
    if (!isImageFileWithExif(file)) {
        return file;
    }
    const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
    const quality = 0.92;
    return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(file);
        };
        img.onload = () => {
            URL.revokeObjectURL(url);
            try {
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    resolve(file);
                    return;
                }
                ctx.drawImage(img, 0, 0);
                canvas.toBlob((blob) => {
                    if (!blob) {
                        resolve(file);
                        return;
                    }
                    const stripped = new File([blob], file.name, {
                        type: outputType,
                        lastModified: Date.now(),
                    });
                    resolve(stripped);
                }, outputType, outputType === 'image/jpeg' ? quality : undefined);
            }
            catch {
                resolve(file);
            }
        };
        img.src = url;
    });
}
//# sourceMappingURL=stripExif.js.map